import { Capacitor } from "@capacitor/core";
import { resolveApiBaseUrl } from "./api/api-origin";

const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isNative = typeof window !== "undefined" &&
  (Capacitor.isNativePlatform() || window.location.protocol === "capacitor:");

export const clientEnv = Object.freeze({
  // An embedded iPhone/Android WebView cannot send /api to localhost.
  // Use the same authenticated ONE CORE backend as the official website.
  apiBaseUrl: resolveApiBaseUrl({ hostname, isNative, configuredBase: configuredApiBaseUrl }),
  appVersion: import.meta.env.VITE_APP_VERSION?.trim() || "1.1.0"
});
